module.exports = __webpack_public_path__ + "img/gb-wls.86b5079c.svg";